module.exports = __webpack_public_path__ + "static/media/ms.ad88044d.svg";